module.exports = __webpack_public_path__ + "img/pleisure_bodyimage13-3.9738805d.jpg";